import { useEffect } from "react";
import {
  useCenterTopologyItemId,
  useComputedTopologyLayout,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";

export function useCenterTopologyItem({ transformRef, viewportRef }) {
  const centerTopologyItemId = useCenterTopologyItemId();
  const layout = useComputedTopologyLayout();

  useEffect(() => {
    if (
      !centerTopologyItemId ||
      !layout?.nodes?.length ||
      !transformRef.current ||
      !viewportRef.current
    ) {
      return;
    }

    const node = layout.nodes.find((n) => n.id === centerTopologyItemId);

    if (!node) {
      return;
    }

    const { instance } = transformRef.current;
    if (!instance) {
      return;
    }

    const { scale } = instance.transformState;
    const viewport = viewportRef.current.getBoundingClientRect();

    const positionX =
      -node.x * scale + viewport.width / 2 - viewport.width * 0.125 - 120;
    const positionY =
      -node.y * scale + viewport.height / 2 - viewport.height * 0.125 - 120;

    requestAnimationFrame(() => {
      transformRef.current.setTransform(positionX, positionY, scale, 300);
    });
  }, [centerTopologyItemId, layout, transformRef, viewportRef]);
}
